import React, { useEffect } from "react";
import { icons } from "../../assets/icons";
import { Link, useLocation } from "react-router-dom";
import InputWithIcon from "../FormFields/InputWithIcon";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import Select from "react-dropdown-select";
import { FaBars, FaCaretDown } from "react-icons/fa";
import { apiUrls } from "../../utils/api/apiUrls";
import useApi from "../../../srcMobile/hooks/useApi";
import NotificationSidebar from "../NotificationSidebar/NotificationSidebar";
import ProfilePic from "../../assets/images/profile1.png";
import { images } from "../../assets/images";

const DashboardHeader = ({ showLogo, isSapActive, isVoucherDownload }) => {
  const location = useLocation();
  const { data = [], apiCall } = useApi();
  const { data: data1, apiCall: apiCall1 } = useApi();
  const { apiCall: notificationCountApi } = useApi(false);
  const { data: storeName, apiCall: getStoreName } = useApi();
  const { data: financeName = [], apiCall: getFinanceName } = useApi();
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);
  const {
    logout,
    user,
    setDashboardVisible,
    setStoreDropdownState,
    selectedManagersDropdownState,
    setSelectedManagersDropdownState,
    setSelectedManagers,
    selectedManagers,
    setProfileDashboardVisible,
    selectedFinanceUser,
    setSelectedFinanceUser,
    storeDropdownState,
    selectedStores,
    setSelectedStores,
  } = useAuth();

  const [notificationCount, setNotificationCount] = useState(0);
  const isFinance = user?.userLabel === "Finance";
  const [storeFilters, setStoreFilters] = useState({
    finance: isFinance ? user?.username : "",
    rm: "",
    am: "",
  });

  const isStore = user?.userLabel === "Store";
  const isL2 = user?.userLabel === "L2";
  const onClickClose = () => {
    setDropDownOpen(false);
  };

  const notificationApiCall = () => {
    notificationCountApi({
      url: `${apiUrls.dmsService.getNotificationCount}`,
      method: "get",
      onSuccess: (data) => {
        console.log("notification count data", data);
        setNotificationCount(data);
      },
    });
  };

  useEffect(() => {
    let notificationCall = setInterval(() => {
      notificationApiCall();
    }, 300 * 1000);
    return () => {
      clearInterval(notificationCall);
    };
  }, []);

  const getAllStoreApi = (params) => {
    let url = ``;
    if (params?.finance) {
      url = `${apiUrls.dmsService.getAllStores}${params?.finance}/${params?.rm}/${params?.am}`;
    } else if (params?.rm && params?.am === "all") {
      url = `${apiUrls.dmsService.getAllStores}${params?.rm}`;
    } else if (params?.am) {
      url = `${apiUrls.dmsService.getAllStores}${params?.am}`;
    }

    if (!url) return;

    apiCall({
      url: url,
      method: "get",
      onSuccess: (data) => {
        setSelectedStores({ storeDetails: { storeCode: "All", name: "All" } });
        setStoreDropdownState(data);
      },
    });
  };

  const getAllRegionalManagerApi = (financeId) => {
    getFinanceName({
      url: `${apiUrls.dmsService.getAllRegionalManager}/${financeId}`,
      method: "get",
      onSuccess: (data) => {
        setSelectedFinanceUser([{ username: "All", name: "All" }]);
        setStoreDropdownState(data);

        setStoreFilters({ ...storeFilters, rm: "all", am: "" });
        getAllManagersApi("all", isFinance ? financeId : "");
      },
      startLoading: false,
    });
  };

  const getAllManagersApi = (rm, finance = "") => {
    let url = `${apiUrls.dmsService.getAllAreaManager}${rm}`;
    if (finance !== "") {
      url = url + `/${finance}`;
    }

    apiCall1({
      url: url,
      method: "get",
      onSuccess: (data) => {
        setSelectedManagersDropdownState(data);
        if (data[0].username) {
          setSelectedManagers([{ username: "All", name: "All" }]);
          let params = {
            finance: finance,
            rm: rm,
            am: "all",
          };
          getAllStoreApi(params);
          setStoreFilters(params);
        }
      },
      startLoading: false,
    });
  };

  useEffect(() => {
    const { username = "", userLabel = "L1" } = user || {};

    if (user?.userLabel === "Finance") {
      setStoreFilters({
        finance: user?.username,
        rm: "",
        am: "",
      });
    }

    if (userLabel === "L1") {
      let params = {
        am: username,
      };
      getAllStoreApi(params);
    }

    if (userLabel === "L2") {
      setStoreFilters({
        finance: "",
        rm: user?.username,
        am: "all",
      });
      getAllManagersApi(username, isFinance ? username : "");
    }

    if (isFinance) {
      getAllRegionalManagerApi(username, username);
    }
  }, [user.username]);

  useEffect(() => {
    getStoreName({
      url: apiUrls.dmsService.getStoreName,
      method: "get",
    });
  }, []);

  const closeNotificationSidebar = () => {
    setNotificationIsOpen(false);
  };

  const dropDownOptions = [
    { name: "Assigned To Me", icon: icons.assignIcon, link: "/assignedtome" },
    { name: "My Account", icon: icons.accountIcon, link: "/myaccount" },
    { name: "Help Center", icon: icons.helpIcon2, link: "/helpcenter" },
    { name: "Raise A Request", icon: icons.raiseIcon, link: "/raisearequest" },
    { name: "Sign Out", icon: icons.signoutIcon, onClick: () => logout() },
  ];

  const [dropDownOpen, setDropDownOpen] = useState(false);

  const renderLeft = () => {
    if (showLogo) {
      return (
        <div className="flex flex-col justify-center  px-3">
          <img
            src={images.mainLogo}
            alt="keventers' logo"
            className="w-[155px] mt-1"
          />
        </div>
      );
    }

    if (["/helpcenter", "/assignedtome"].includes(location.pathname)) {
      return <div />;
    }

    if (location.pathname === "/myaccount") {
      <InputWithIcon
        placeholder="Search"
        containerClassName="!w-[48rem] !h-[5rem] !bg-[var(--whiteColor)] !px-[2rem] shadow-[0_0_6px_#00000029]"
        inputClassName="flex font-size-medium placeholder-[var(--lightGray)]"
        rightIcon={icons.searchIcon}
      />;
    }

    return (
      !isSapActive &&
      !isVoucherDownload && (
        <div className="flex flex-wrap">
          {isFinance && (
            <Select
              dropdownGap={-8}
              wrapperClassName="!w-[100%]"
              className="!border-[0px] !w-[11rem] dropdown"
              options={[{ username: "All", name: "All" }, ...financeName]}
              labelField="name"
              valueField="username"
              onChange={(val) => {
                // getAllManagersApi(val[0].username || "");
                let isAllSelect = val?.find((i) => i.username === "All");
                if (
                  isAllSelect?.username &&
                  isAllSelect?.username === "All" &&
                  user?.username
                ) {
                  // debugger
                  getAllManagersApi("all", isFinance ? user?.username : "");
                  setStoreFilters({ ...storeFilters, rm: "all", am: "" });
                } else {
                  getAllManagersApi(
                    val[0]?.username || "",
                    isFinance ? user?.username : ""
                  );
                  setStoreFilters({
                    ...storeFilters,
                    rm: val[0]?.username,
                    am: "",
                  });
                }

                setSelectedFinanceUser({ storeDetails: val[0] });
              }}
              contentRenderer={() => {
                return (
                  <div className="store-details-container">
                    <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                      Regional Manager
                    </div>
                    <div className="flex items-center gap-x-3 !w-[100%]">
                      <div className="text-[1.8rem]">
                        {/* {selectedFinanceUser?.storeDetails?.name || "Please Select"} */}
                        {selectedFinanceUser?.storeDetails?.username ||
                          selectedFinanceUser[0]?.username ||
                          "All"}
                      </div>

                      <FaCaretDown size={15} className="mt-1" />
                    </div>
                  </div>
                );
              }}
              dropdownHandle={false}
            />
          )}
          {data1?.length && (
            <Select
              dropdownGap={-8}
              wrapperClassName="!w-[100%]"
              className="!border-[0px] !w-[10rem] dropdown"
              options={[{ username: "All", name: "All" }, ...data1]}
              labelField="name"
              valueField="username"
              onChange={(val) => {
                let isAllSelect = val?.find((i) => i.username === "All");
                if (
                  isAllSelect?.username &&
                  isAllSelect?.username === "All" &&
                  user?.username
                ) {
                  // debugger
                  let params = {
                    ...storeFilters,
                    am: "all",
                  };
                  getAllStoreApi(params);
                } else {
                  let params = {
                    ...storeFilters,
                    am: val[0]?.username,
                  };
                  getAllStoreApi(params);
                }
                setSelectedManagers({ storeDetails: val[0] });
              }}
              contentRenderer={() => {
                return (
                  <div className="store-details-container">
                    <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                      Area Manager
                    </div>
                    <div className="flex items-center gap-x-3 !w-[100%]">
                      <div className="text-[1.8rem]">
                        {selectedManagers?.storeDetails?.name ||
                          selectedManagers[0]?.username ||
                          "All"}
                      </div>

                      {(isL2 || isFinance) && (
                        <FaCaretDown size={15} className="mt-1" />
                      )}
                    </div>
                  </div>
                );
              }}
              dropdownHandle={false}
            />
          )}
          {data.length ? (
            data.length ? (
              <Select
                dropdownGap={-8}
                wrapperClassName="!w-[100%]"
                className="!border-[0px] dropdown"
                options={[
                  // { name: "Please select", storeCode: "" },
                  { storeCode: "All", name: "All" },
                  ...data?.map((item) => ({
                    name: `${item?.name} (${item?.storeCode})`,
                    storeCode: item?.storeCode,
                  })),
                ]}
                labelField="name"
                valueField="storeCode"
                onChange={(val) => setSelectedStores({ storeDetails: val[0] })}
                contentRenderer={() => {
                  return (
                    <div className="store-details-container">
                      <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                        Store
                      </div>
                      <div
                        className="font-family-medium flex text-2xl mt-1.5	items-center"
                        style={{ fontSize: "1.8rem" }}
                      >
                        {/* {selectedStores?.storeDetails?.name || "All"} */}
                        {selectedStores?.storeDetails?.storeCode ||
                          selectedStores[0]?.storeCode ||
                          "All"}
                        <FaCaretDown size={12} className="" />
                      </div>
                    </div>
                  );
                }}
                dropdownHandle={false}
                values={
                  selectedStores?.storeDetails?.storeCode
                    ? [selectedStores?.storeDetails]
                    : [selectedStores[0]]
                }
              />
            ) : null
          ) : storeName && isStore ? (
            <div className="font-family-medium flex text-2xl	items-center">
              {storeName}
            </div>
          ) : null}
        </div>
      )
    );
  };

  const notificationCountCss = {
    position: "absolute",
    top: "9px",
    right: "4px",
    border: "none",
    background: "red",
    borderRadius: "7px",
    width: "15px",
    height: "15px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <div
      className={`header-container ${
        isSapActive ? "justify-end" : "justify-between"
      }`}
    >
      <div className="flex items-start gap-x-4">
        <FaBars
          size={30}
          onClick={() => {
            setDashboardVisible(true);
          }}
          className="mt-2"
        />
        {renderLeft()}
      </div>
      <div className="flex items-center gap-x-[1rem]">
        <div className="relative">
          <img
            src={icons.bellIcon}
            alt="Notification Bell Icon"
            className="w-[4rem] h-[4rem] cursor-pointer"
            onClick={() => {
              notificationApiCall(); // to update call count status
              setNotificationIsOpen(true);
            }}
          />
          {notificationCount > 0 && (
            <span
              className="text-white font-semibold"
              style={notificationCountCss}
            >
              {notificationCount || ""}
            </span>
          )}
        </div>
        <div
          className={`px-5 relative ${
            dropDownOpen ? "shadow-[0_0_6px_#00000029] bg-[#fff]" : ""
          }`}
        >
          <div
            className="flex gap-x-[1.2rem] cursor-pointer pb-2 pt-1 select-none"
            onClick={() => setProfileDashboardVisible(true)}
            style={{ width: "55px" }}
          >
            <div className="flex items-center cursor-pointer gap-x-2">
              <img
                // src="https://picsum.photos/200/300"
                src={ProfilePic}
                className="user-image"
                alt="user"
              />
              <img
                src={icons.arrowDown}
                alt="arrow down"
                className={`h-[0.9rem] w-[1.4rem] arrow ${
                  dropDownOpen ? "rotate" : ""
                }`}
              />
            </div>
          </div>
          <div
            className={`profile-dropdown min-h-[10rem] w-[100%] absolute z-50 bg-[var(--whiteColor)] left-0 font-size-small text-[var(--darkGray)] ${
              dropDownOpen ? "unhide-dropdown" : ""
            }`}
          >
            {dropDownOptions.map((item) => {
              if (item?.link) {
                return (
                  <Link
                    to={item.link}
                    className="flex items-center gap-x-4"
                    key={item.name}
                    onClick={onClickClose}
                  >
                    <img src={item.icon} alt={item.name} />
                    <div>{item.name}</div>
                  </Link>
                );
              } else {
                return (
                  <div
                    className="flex items-center gap-x-4"
                    key={item.name}
                    onClick={item.onClick}
                  >
                    <img src={item.icon} alt={item.name} />
                    <div>{item.name}</div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
      {notificationIsOpen && (
        <NotificationSidebar
          closeNotificationSidebar={closeNotificationSidebar}
          notificationCount={notificationCount}
          notificationIsOpen={notificationIsOpen}
        />
      )}
    </div>
  );
};

export default DashboardHeader;
